import { useAllPartnerAgencyCompanyQuery } from '@anytag/graphql';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { PartnersFilter, PartnersList, useAccountsFilter } from '@anytag/shared-organisms';

export const Partners = () => {
  useUpdateDocumentTitle({ title: 'appHeader.Partner', appHeader: 'appHeader.Partner' });
  const { page, limit, filter } = useAccountsFilter();
  const { data, previousData, loading } = useAllPartnerAgencyCompanyQuery({
    fetchPolicy: 'network-only',
    variables: getValuableVariables({
      ...filter,
      limit,
      offset: getOffset(page, limit),
      verifiedStatus: filter.verifiedStatus || null
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.allPartnerAgenciesCount?.totalNumber;

  return (
    <div>
      <Header />

      <ListWithPagination pagination={{ totalRecords }}>
        <PartnersFilter />
        <PartnersList loading={loading} totalRecords={totalRecords} data={result?.allPartnerAgencyCompany || []} />
      </ListWithPagination>
    </div>
  );
};
